import { useTranslation } from 'react-i18next'
import { EasyPaySubmittedLayout } from 'containers/Premiums/components/EasyPaySubmittedLayout'
import { MyInternalLink, MyLink } from 'components/MyLink'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useMedicareUrl } from 'hooks/useMedicareUrl'
import { useEvent } from 'hooks/useEvent'

export const PayPremiumsLink: React.FC = ({ children }: { children?: React.ReactNode }) => {
  const flags = useFlags()
  const { fireEvent } = useEvent('premiumsEasyPay')
  const legacyMakeAPaymentHref = useMedicareUrl(
    'https://www.medicare.gov/mbp/PremiumPayment.aspx',
    'https://www.medicare.gov/mbp/PremiumPayment.aspx?Lang=es-mx'
  )

  if (flags?.useNewPremiumsPay) {
    return (
      <MyInternalLink to="/premiums/make-a-payment" onClick={(params) => fireEvent('premiums_easypaysignupsuccess_makepayment_click', params)}>{children}</MyInternalLink>
    )
  }

  return (
    <MyLink href={legacyMakeAPaymentHref} onClick={(params) => fireEvent('premiums_easypaysignupsuccess_makepayment_click', params)}>
      {children}
    </MyLink>
  )
}

export const EasyPaySignupSubmitted: React.FC = () => {
  const { t } = useTranslation('easyPaySignupSubmitted')

  return (
    <EasyPaySubmittedLayout
      t={t}
      whatNextBulletComponents={{
        link1: <PayPremiumsLink />
      }}
      pageType='easypaysignupsuccess'
    />
  )
}
